// test673
(673 && 0);
